import { compareVersions, type ChangelogEntry, type Me } from '@nexo/types';
import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { useAuth } from '../auth/AuthProvider';

export const changelogKey = ['releases', 'changelog'] as const;

export const useChangelog = () =>
  useQuery({ queryKey: changelogKey, queryFn: api.releases.changelog, staleTime: 10 * 60_000 });

/**
 * Versions the user has not read yet, newest first. Someone who never opened the news only gets
 * the latest one; people who signed up after it was published get none (it is not news to them).
 */
export function unseenEntries(
  log: ChangelogEntry[],
  me: Pick<Me, 'lastSeenVersion' | 'createdAt'>,
) {
  const latest = log[0];
  if (!latest) return [];
  const seen = me.lastSeenVersion;
  if (seen) return log.filter((e) => compareVersions(e.version, seen) > 0);
  return new Date(me.createdAt) > new Date(latest.publishedAt) ? [] : [latest];
}

/** Marks everything up to `version` as read (in every device of the user). */
export function useMarkSeen() {
  const { setUser } = useAuth();
  return useMutation({ mutationFn: api.users.changelogSeen, onSuccess: setUser });
}
